import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment/moment'
import { dataDefault } from 'Components/User/TransformerTests/TransTests'
import { apiTransformerTestsList, apiTransformerTestsView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/transformerTests/getData', async datas => {
    const { data } = await apiTransformerTestsList(datas)
    return data
})

export const getView = createAsyncThunk('admin/transformerTests/getView', async datas => {
    var id = datas.id ? datas.id : datas.clone_id
    if (!id) return viewData
    const { data } = await apiTransformerTestsView(id, datas.report ? { report: true } : {})
    data.trans_test =
        data.trans_test && data.trans_test.length !== 0
            ? data.trans_test.map(item => {
                  return {
                      ...item,
                      details: { ...(item?.details ?? '') },
                      inspector_id: item?.inspectors?.map(value => value?.inspector_id),
                      user_id: item?.users?.map(value => value?.user_id),
                      authorised_id: item?.inspectors
                          ?.filter(e => e.authorised.toString() === '1')
                          .map(value => value?.inspector_id),
                  }
              })
            : [dataDefault]
    return data
})

const viewData = {
    project_id: '',
    transformer_id: '',
    test_report_no: '',
    ulr_no: '',
    type: '',
    type_test: '',
    stage_level: '',
    inspector_start_date: '',
    inspector_end_date: '',
    report_submission_date: '',
    planned_start_date: moment().format('YYYY-MM-DD'),
    planned_end_date: moment().format('YYYY-MM-DD'),
    actual_start_date: moment().format('YYYY-MM-DD'),
    actual_end_date: moment().format('YYYY-MM-DD'),
    date_of_item_receipt: moment().format('YYYY-MM-DD'),
    trans_test: [dataDefault],
}

export const transformerTestsSlice = createSlice({
    name: 'admin/transformerTests',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 50,
            search: '',
            column: '',
            dir: '',
            start: moment().startOf('year').locale('en').format('YYYY-MM-DD'),
            end: moment().endOf('year').locale('en').format('YYYY-MM-DD'),
            no_of_phases: '',
            vector_group: '',
            rated_frequency: '',
            type: '',
            type_test: '',
            status: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setDate: (state, { payload: { start, end } }) => {
            state.table.page = 1
            state.table.start = start
            state.table.end = end
        },
        setPhases: (state, { payload }) => {
            state.table.page = 1
            state.table.no_of_phases = payload
        },
        setVectorGroup: (state, { payload }) => {
            state.table.page = 1
            state.table.vector_group = payload
        },
        setRatedFrequency: (state, { payload }) => {
            state.table.page = 1
            state.table.rated_frequency = payload
        },
        setType: (state, { payload }) => {
            state.table.page = 1
            state.table.type = payload
        },
        setTypeTest: (state, { payload }) => {
            state.table.page = 1
            state.table.type_test = payload
        },
        setStatus: (state, { payload }) => {
            state.table.page = 1
            state.table.status = payload
        },
        setReset: state => {
            state.table.page = 1
            state.table.start = moment().startOf('year').locale('en').format('YYYY-MM-DD')
            state.table.end = moment().endOf('year').locale('en').format('YYYY-MM-DD')
            state.table.no_of_phases = ''
            state.table.vector_group = ''
            state.table.rated_frequency = ''
            state.table.type = ''
            state.table.type_test = ''
            state.table.status = ''
        },
        setFinalTestingTL: state => {
            state.table.page = 1
            state.table.type = 1
            state.table.type_test = 4
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const {
    setData,
    setTableData,
    setDate,
    setPhases,
    setVectorGroup,
    setRatedFrequency,
    setType,
    setTypeTest,
    setStatus,
    setReset,
    setFinalTestingTL,
} = transformerTestsSlice.actions

export default transformerTestsSlice.reducer
